import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Album from '@/views/Album.vue'
import About from '@/views/About.vue'
import store from "../store";

Vue.use(VueRouter)

const routes = [
	{
		path: '/about',
		name: 'about',
		component: About,
		props: {pageRender: true},
	},
	{
		path: '/:url_title',
		name: 'album',
		component: Album,
		props: true,
		beforeEnter: function (to, from, next) {
			if (store.getters.itemByUrl(to.params.url_title)) {
				next();
			} else {
				next('/')
			}
		}
	},
	{
		path: '/*',
		name: 'home',
		component: Home
	},
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
})

export default router
